export const getAuthConfig = () => {
    if (window.location.hostname === "localhost") {
        return {
            auth: {
                username: process.env.REACT_APP_AUTH_USERNAME,
                password: process.env.REACT_APP_AUTH_PASSWORD
            }
        };
    }
    return null
};

export const getValidateConfig = () => {
    // Don't set content-type manually — axios auto-sets it with the
    // required boundary when sending FormData.
    if (window.location.hostname === "localhost") {
        return {
            auth: {
                username: process.env.REACT_APP_AUTH_USERNAME,
                password: process.env.REACT_APP_AUTH_PASSWORD
            }
        };
    }
    return {}
}

export const getInstanceConfigValue = (segment, field, config) => {
    const configItem = config.find(item => item?.segment === segment && item?.field === field);
    return configItem ? configItem?.value : undefined;
}

// File utilities for BotMaterials
export const FILE_CONFIG = {
    MAX_FILE_SIZE: 50 * 1024 * 1024, // 50MB (OpenAI)
    MAX_FILE_SIZE_GEMINI: 10 * 1024 * 1024, // 10MB (Vertex AI RAG)
    MAX_TOTAL_SIZE: 200 * 1024 * 1024, // 200MB total
    MAX_TOTAL_SIZE_GEMINI: 200 * 1024 * 1024, // 200MB total per corpus (Vertex AI RAG)
    ALLOWED_EXTENSIONS: ['.pdf', '.docx', '.doc', '.txt', '.md', '.json', '.csv'],
    ALLOWED_EXTENSIONS_GEMINI: ['.html', '.json', '.jsonl', '.md', '.pptx', '.docx', '.pdf', '.txt'],
    ALLOWED_MIME_TYPES: [
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/msword',
        'text/plain',
        'text/markdown',
        'application/json',
        'text/csv'
    ]
};

export const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    if (!bytes) return 'Unknown';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
};

export const validateFileType = (filename) => {
    const fileExt = '.' + filename.split('.').pop().toLowerCase();
    return FILE_CONFIG.ALLOWED_EXTENSIONS.includes(fileExt);
};

export const getTotalFilesSize = (materials) => {
    return materials.reduce((total, material) => {
        return total + (material.size || 0);
    }, 0);
};

export const migrateLegacyMaterial = (material) => {
    // If it's already an object with id, return as-is
    if (typeof material === 'object' && material !== null) {
        return material;
    }

    // If it's a legacy string, create a placeholder object
    return {
        id: null,
        filename: material,
        size: 0,
        uploadedAt: null,
        uploadedBy: 'legacy',
        purpose: 'assistants',
        mimeType: 'unknown',
        isLegacy: true
    };
};